import React from "react";
import {
  AuthLayoutMediaSurface,
  AuthLayoutGridLayoutSecondary,
  AuthLayoutPanelEyebrow,
  AuthLayoutPanelCard,
  AuthLayoutSectionBody,
  AuthLayoutMediaSurfaceSecondary,
  AuthLayoutGridLayout,
  AuthLayoutSection,
  AuthLayoutSectionSecondary,
  AuthLayoutSectionTertiary,
  AuthLayoutInfoRow,
  AuthLayoutPageHeading,
  AuthLayoutIllustrationImageSecondary,
  AuthLayoutIllustrationImage,
  AuthLayoutEyebrowText,
  AuthLayoutTextBlock,
  AuthLayoutBodyText,
  AuthLayoutTextBlockSecondary,
  AuthLayoutMapFrame,
  AuthLayoutMapStage,
  AuthLayoutMapTile,
  AuthLayoutMapTrack,
} from "components/layouts/auth-layout/styles/auth-layout.inline.styles";

const authLayoutHighlights = [
  {
    eyebrow: "Access",
    text: "Role-aware access for admin, athlete, fan, and school-management workflows",
  },
  {
    eyebrow: "Data",
    text: "Fast search, filters, and drill-down views across the latest API-backed datasets",
  },
  {
    eyebrow: "Operations",
    text: "Operational screens for catalog, commerce, schools, requests, wallet, and news",
  },
];

export const AuthLayout: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <AuthLayoutMediaSurface>
      <AuthLayoutSectionBody>
        <AuthLayoutMediaSurfaceSecondary>
          <AuthLayoutGridLayout>{children}</AuthLayoutGridLayout>
        </AuthLayoutMediaSurfaceSecondary>
      </AuthLayoutSectionBody>

      <AuthLayoutSection>
        <AuthLayoutMapFrame aria-hidden="true">
          <AuthLayoutMapStage>
            <AuthLayoutMapTrack>
              {[0, 1].map((mapInstance) => (
                <AuthLayoutMapTile key={mapInstance}>
                  <AuthLayoutIllustrationImage
                    alt=""
                    decoding="async"
                    loading="eager"
                    src="/assets/images/auth/world-map-simple.svg"
                  />
                </AuthLayoutMapTile>
              ))}
            </AuthLayoutMapTrack>
          </AuthLayoutMapStage>
        </AuthLayoutMapFrame>
        <AuthLayoutSectionSecondary />
        <AuthLayoutSectionTertiary>
          <div>
            <AuthLayoutInfoRow>
              <AuthLayoutIllustrationImageSecondary
                alt="Athspire logo"
                src="/assets/images/brand/athspire-logo.svg"
              />
              <div>
                <AuthLayoutEyebrowText>Athspire</AuthLayoutEyebrowText>
                <AuthLayoutTextBlock>Portal Access</AuthLayoutTextBlock>
              </div>
            </AuthLayoutInfoRow>
            <AuthLayoutEyebrowText>Multi-Role Workspace</AuthLayoutEyebrowText>
            <AuthLayoutPageHeading>
              Open the Athspire workspace built for your role.
            </AuthLayoutPageHeading>
            <AuthLayoutBodyText>
              Move between catalog management, athlete operations, school workflows, commerce, and
              self-service tools without hopping between disconnected screens.
            </AuthLayoutBodyText>
          </div>

          <AuthLayoutGridLayoutSecondary>
            {authLayoutHighlights.map((item) => (
              <AuthLayoutPanelCard key={item.eyebrow}>
                <AuthLayoutPanelEyebrow>{item.eyebrow}</AuthLayoutPanelEyebrow>
                <AuthLayoutTextBlockSecondary>{item.text}</AuthLayoutTextBlockSecondary>
              </AuthLayoutPanelCard>
            ))}
          </AuthLayoutGridLayoutSecondary>
        </AuthLayoutSectionTertiary>
      </AuthLayoutSection>
    </AuthLayoutMediaSurface>
  );
};
